import {YClientsFormContactFields} from '@target-web/leadads-form-view';
import {ContactInfoFormStateInner} from 'core/types';

export const emailRegexp = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const phoneRegexp = /^[+][(\s\-/\d)]{11}$/;
export const dateRegexp = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;

const REQUIRED_FIELD_MESSAGE = 'Обязательное поле';

const required = (value: string): string => {
    if (!value.trim()) {
        throw new Error(REQUIRED_FIELD_MESSAGE);
    }
    return value;
};

const email = (value: string) => {
    required(value);
    if (value.includes('***')) {
        return value;
    }
    if (!emailRegexp.test(value)) {
        throw new Error('Некорректный email адрес');
    }
    return value;
};

const phone = (value: string): string => {
    if (value.includes('**')) {
        // в случае автозаполнения скипаем проверку
        return value;
    }
    if (value.length !== 10 || !value.startsWith('9')) {
        throw new Error('Некорректный номер телефона');
    }
    return value;
};

export type Validations = {
    [key in keyof Partial<ContactInfoFormStateInner>]: (value: string) => string;
};

// для лидформ
export const validations: Validations = {
    first_name: required,
    email: email,
    phone: phone,
    birth_date: required,
    city: required,
};

// для yclients
export const validatorByField: Partial<
    Record<YClientsFormContactFields, (v: string, isFilled: boolean) => string | boolean>
> = {
    fullname: (v) => {
        if (!v) return 'Обязательное поле';
        return false;
    },
    phone: (v) => {
        if (!v) return 'Обязательное поле';
        if (v.length < 10) return true;
        return false;
    },
    email: (v, isFilled) => {
        if (v && !isFilled && !emailRegexp.test(v)) {
            return 'Некорректный email';
        }
        return false;
    },
};
